export default __webpack_public_path__ + "static/media/Mark-4-HUD-Process Info.98553e51.jpg";